import { createContext } from "react";

export interface LayoutState {
  openSidebar: boolean;
  setOpenSidebar: (open: boolean) => void;
  openSignOut: boolean;
  setOpenSignOut: (open: boolean) => void;
  profile?: string;
  setProfile: (base64: string | undefined) => void;
  /**
   * Extra, already-translated last breadcrumb for a page whose title is data,
   * e.g. the borrower name on /financed-emissions/borrowers/:id. The page sets
   * it and clears it (undefined) when it unmounts.
   */
  breadcrumbTail?: string;
  setBreadcrumbTail: (text: string | undefined) => void;
}

export const LayoutContext = createContext<LayoutState>({
  openSidebar: false,
  setOpenSidebar: () => {},
  openSignOut: false,
  setOpenSignOut: () => {},
  profile: undefined,
  setProfile: () => {},
  breadcrumbTail: undefined,
  setBreadcrumbTail: () => {},
});
